import React from 'react';
import './user_menu.scss';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { logout } from 'stores/User/userActions';
import { Link, withRouter } from 'react-router-dom';
import { urlFormatter } from '../../../../util';
import Modal from 'components/ui_elements/Modal';

import SubscribersList from './SubscribersList';

import dashboard from '../../../../assets/img/icon/Dashboard.svg';
import autoRecharge from '../../../../assets/img/icon/Auto Recharge.svg';
import bounceBalance from '../../../../assets/img/icon/Bounce Balance.svg';
import logIn from '../../../../assets/img/icon/Log in.svg';
import manageAccount from '../../../../assets/img/icon/Manage Account.svg';
import transfer from '../../../../assets/img/icon/Transfer.svg';
import prepaidYalla from '../../../../assets/img/Menu Ads Graphics.png';
import googlePlay from '../../../../assets/img/google_play.svg';
import appStore from '../../../../assets/img/app_store.svg';
import { initiateUser } from 'services/user.service';
import Translation from '../../../../services/translation.service';
import AccountSwitcher from '../AccountSwitcher';

const UserMenu = ({ loggedIn, logout, links }) => {
  const loginLink =
    urlFormatter(links?.['informative-login']?.['route']) ||
    urlFormatter(links?.['informative-login']?.['1']?.['route']);
  const dashboardLink =
    urlFormatter(links?.['wsc-dashboard-usage']?.['route']) ||
    urlFormatter(links?.['wsc-dashboard-usage']?.['1']?.['route']);
  const autoRechargeLink =
    urlFormatter(links?.['informative-auto_recharge']?.['route']) ||
    urlFormatter(links?.['informative-auto_recharge']?.['1']?.['route']);
  const manageAccountLink =
    urlFormatter(links?.['wsc-dashboard-manage_account']?.['route']) ||
    urlFormatter(links?.['wsc-dashboard-manage_account']?.['1']?.['route']);

  const [showSubscribersAccounts, setShowSubscribersAccounts] =
    React.useState(false);

  const showSubscribersAccountsModal = React.useCallback(() => {
    setShowSubscribersAccounts(!showSubscribersAccounts);
  }, [showSubscribersAccounts]);
  return (
    <>
      {showSubscribersAccounts ? (
        <AccountSwitcher
          showSubscribersAccountsModal={showSubscribersAccountsModal}
        />
      ) : (
        ''
      )}
      <div
        className={
          !loggedIn
            ? 'sub-nav-wrapper sub-nav-wrapper_logged-in'
            : 'sub-nav-wrapper'
        }
      >
        <div className="sub-nav flex-align-center">
          <div
            className="nav-section"
            style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}
          >
            <Link to={dashboardLink} className="sub-nav-list-lnk wide">
              {/* <img src={dashboard} /> */}
              {Translation.key('usermenu_dashboard')}
            </Link>
            {/* <Link to={autoRechargeLink} className="sub-nav-list-lnk wide">
              <img src={autoRecharge} />
              {Translation.key('usermenu_auto_recharge')}
            </Link>
            <Link to={dashboardLink} className="sub-nav-list-lnk wide">
              <img src={bounceBalance} />
              {Translation.key('usermenu_bounce_balance')}
            </Link> */}

            {/* <Link to={dashboardLink} className="sub-nav-list-lnk wide">
              <img src={transfer} />
              {Translation.key('usermenu_transfer')}
            </Link> */}

            {loggedIn && (
              <a
                className="sub-nav-list-lnk wide"
                onClick={() => {
                  initiateUser();
                  showSubscribersAccountsModal();
                }}
              >
                {/* <img src={manageAccount} /> */}
                {Translation.key('switch_account1.0_lbl1.0_switch_account')}
              </a>
            )}

            <Link to={manageAccountLink} className="sub-nav-list-lnk wide">
              {/* <img src={manageAccount} /> */}
              {Translation.key('usermenu_manage_account')}
            </Link>

            {loggedIn ? (
              <Link className="sub-nav-list-lnk wide" onClick={() => logout()}>
                <img style={{ transform: 'scaleX(-1)' }} src={logIn} />
                {Translation.key('log_out')}
              </Link>
            ) : (
              <Link className="sub-nav-list-lnk wide" to={loginLink}>
                <img src={logIn} /> &nbsp;{Translation.key('log_in')}
              </Link>
            )}
          </div>
          <div className="nav-section-image column">
            {/* <Link
              className="nav-button-image large"
              style={{
                background:
                  ' linear-gradient(307.04deg, #6CCAA3 16.9%, #1978CD 90.84%)',
                color: 'white',
              }}
            ></Link> */}
            <p className="image-title">
              {Translation.key('download_app_menu_button')}
            </p>
            <div className="app-images">
              <a
                href="https://apps.apple.com/sa/app/lebara-ksa/id1269029448"
                target="_blank"
              >
                <img src={appStore} />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.netvariant.lebara"
                target="_blank"
              >
                <img src={googlePlay} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loggedIn: state.user.loggedIn,
    subscribersList: state.user.subscribersList,
    selectedSubscriber: state.user.selectedSubscriber,
    links: state.layout.routes,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ logout }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserMenu));
